import React, { useState } from "react";
import IntegrationsTable from "./ingredientsTable";
import ProductsTable from "./productsTable";
import AdminSupplierTable from "./supplierTable";
import AdminPackagingTable from "./packagingTable";
import IngredientsTable from "./ingredientsTable";
import ReportsTable from "./reportsTable";
import CountDetails from "./countDetails";
import AnonymousDataMigration from "./anonymousDataMigration";


const AdminMainData: React.FC = () => {
  const [activeTab, setActiveTab] = useState("ingredients");

  const tabs = [
    { id: "ingredients", label: "Ingredients", component: <IngredientsTable /> },
    { id: "products", label: "Products", component: <ProductsTable /> },
    { id: "suppliers", label: "Suppliers", component: <AdminSupplierTable /> },
    { id: "packaging", label: "Packaging", component: <AdminPackagingTable /> },
    { id: "reports", label: "Reports", component: <ReportsTable /> },
    { id: "count", label: "Count", component: <CountDetails />},
    { id: "anonymous", label: "Anonymous Data", component: <AnonymousDataMigration /> }
  ];

  return (
    <div className="admin-data-container">
      {/* Header */}
      <div className="admin-data-container__header">
        <h3>Data Management</h3>
        <p>
          Manage ingredients, products, suppliers, packaging, and reports across your platform.
        </p>
      </div>

      {/* Tabs */}
      <ul className="admin-data-container__tabs nav nav-tabs" id="myTab" role="tablist">
        {tabs.map((tab) => (
          <li key={tab.id} className="nav-item">
            <a
              className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
              id={`${tab.id}-tab`}
              data-toggle="tab"
              href={`#${tab.id}`}
              role="tab"
              onClick={(e) => {
                e.preventDefault();
                setActiveTab(tab.id);
              }}
            >
              {tab.label}
            </a>
          </li>
        ))}
      </ul>

      {/* Tab Content */}
      <div className="admin-data-container__content tab-content" id="myTabContent">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""}`}
            id={tab.id}
            role="tabpanel"
          >
            {tab?.component}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminMainData;
